// routes.js
import Home from "./Home";
// import About from "./About";
import Login from "./Login";

import PageForgetPassword from "./pages/ForgetPassword";
import PageOtpForget from "./pages/OtpForget";
import PageNewPassword from "./pages/NewPassword";

import Register from "./pages/Register";
import Menu from "./pages/MainTab";
import OTP from "./pages/OtpVerification";
import MainTab from "./pages/MainTab";
import ProfileEdit from "./pages/ProfileEdit";
// import PageCart_ from "./pages/Cart_";
import PageOrdersDetails from "./pages/OrdersDetails";
import PageFoodListing from "./pages/FoodListing";
import PageCuisineType from "./pages/CuisineType";
import PageNotification from "./pages/Notification";
import PageSettingEdit from "./pages/SettingEdit";
import PageWalletEdit from "./pages/WalletEdit";
import PageCardAdd from "./pages/CardAdd";
import PageOrder from "./pages/Order";
import PageAbout from "./pages/About";
import PageEventDetail from "./pages/EventDetail";
import PagePayment from "./pages/Payment";
import PageEventRestDetail from "./pages/EventRestDetails";
import PageEventAcceptDetail from "./pages/EventAcceptDetails";
import PageRestaurantDetail from "./pages/RestaurantDetail";
import PageSearchRestaurant from "./pages/SearchRestaurantPage";
import PageCart from "./pages/Cart";
import PageAddEvent from "./pages/AddEvent";
import BidTab from "./pages/BidsTab";
import PageHelp from "./pages/Help";
import PagePaymentSuccess from "./pages/PaymentSuccess";
import PageCanOrderDetails from "./pages/CanOrderDetails";
import OrdersCanListPage from "./pages/OrdersCanList";
import PageEditEvent from "./pages/EditEvent";
import PageSearchEventOrder from "./pages/SearchEventOrderPage";
import PageAccountEdit from "./pages/AccountEdit";
import Page404 from "./404";
import ExpiredOrderListPage from "./pages/ExpiredOrderList";
import PageExpiredOrderDetailsPage from "./pages/ExpiredOrderDetails";

const routes = [
  {
    path: "/",
    component: Home,
    options: {
      force: true,
    },
  },
  {
    path: "/login/",
    component: Login,
    options: {
      force: true,
    },
  },
  {
    path: "/otpverify/",
    component: OTP,
    options: {
      force: true,
    },
  },
  {
    path: "/register/",
    component: Register,
    options: {
      force: true,
    },
  },
  {
    path: "/forgetpassword/",
    component: PageForgetPassword,
    options: {
      force: true,
    },
  },
  {
    path: "/otpforget/",
    component: PageOtpForget,
    options: {
      force: true,
    },
  },
  {
    path: "/newpassword/",
    component: PageNewPassword,
    options: {
      force: true,
    },
  },
  {
    path: "/main/",
    component: MainTab,
    options: {
      force: true,
    },
  },
  {
    path: "/menu/",
    component: Menu,
    options: {
      force: true,
    },
  },
  {
    path: "/profileedit/",
    component: ProfileEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/cart/:id",
    component: PageCart,
    options: {
      force: true,
    },
  },
  {
    path: "/orderdetails/",
    component: PageOrdersDetails,
    options: {
      force: true,
    },
  },
  {
    path: "/order_details/:id",
    component: PageOrdersDetails,
    options: {
      force: true,
    },
  },
  {
    name: "cuisine",
    path: "/cuisinetype/:cid/",
    component: PageCuisineType,
    options: {
      force: true,
    },
  },
  {
    path: "/foodlisting/",
    component: PageFoodListing,
    options: {
      force: true,
    },
  },
  {
    path: "/notification/",
    component: PageNotification,
    options: {
      force: true,
    },
  },
  {
    path: "/wallet/",
    component: PageWalletEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/cardadd/",
    component: PageCardAdd,
    options: {
      force: true,
    },
  },
  {
    name: "bidtab",
    path: "/bidtab/",
    component: BidTab,
    option: {
      force: true,
    },
  },
  {
    path: "/setting/",
    component: PageSettingEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/order/",
    component: PageOrder,
    options: {
      force: true,
    },
  },
  {
    path: "/eventdetail/:id",
    component: PageEventDetail,
    options: {
      force: true,
    },
  },
  {
    path: "/eventrestdetails/:id/:rid",
    component: PageEventRestDetail,
    options: {
      force: true,
    },
  },
  {
    path: "/eventacceptdetails/:id/:rid",
    component: PageEventAcceptDetail,
    options: {
      force: true,
    },
  },
  {
    name: "payment",
    path: "/payment/:id",
    component: PagePayment,
    options: {
      force: true,
    },
  },
  {
    name: "searchRestaurant",
    path: "/searchRestaurant/",
    component: PageSearchRestaurant,
    options: {
      force: true,
    },
  },
  {
    path: "/restaurantdetail/:id/",
    component: PageRestaurantDetail,
    options: {
      force: true,
    },
  },
  {
    path: "/addevent/",
    component: PageAddEvent,
    options: {
      force: true,
    },
  },
  {
    path: "/about/",
    component: PageAbout,
    options: {
      force: true,
    },
  },
  {
    path: "/help/",
    component: PageHelp,
    options: {
      force: true,
    },
  },
  {
    path: "/payment-success/",
    component: PagePaymentSuccess,
    options: {
      force: true,
    },
  },
  {
    path: "/order_can_list/",
    component: OrdersCanListPage,
    options: {
      force: true,
    },
  },
  {
    path: "/order_exp_list/",
    component: ExpiredOrderListPage,
    options: {
      force: true,
    },
  },
  {
    path: "/expiredorder/:id/",
    component: PageExpiredOrderDetailsPage,
    options: {
      force: true,
    },
  },
  {
    path: "/cancelevent/:id/",
    component: PageCanOrderDetails,
    options: {
      force: true,
    },
  },
  {
    path: "/edit_event/:id/",
    component: PageEditEvent,
    options: {
      force: true,
    },
  },
  {
    path: "/eventordersearch/",
    component: PageSearchEventOrder,
    options: {
      force: true,
    },
  },
  {
    path: "/deleteaccount/",
    component: PageAccountEdit,
    options: {
      force: true,
    },
  },
  {
    path: "(.*)",
    component: Page404,
  },
];

export default routes;
